import {Link} from 'react-router-dom';
import clsx from 'clsx';
import React, {useMemo} from 'react';
import {slugifyString} from '@ui/utils/string/slugify-string';
import {Playlist} from '@app/web-player/playlists/playlist';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {isIOSOrAndroid} from '@common/core/platform-detection';
import {StackTrigger} from '@ui/overlays/stack-navigator/stack-trigger';
import {PlaylistPage} from '@app/web-player/playlists/playlist-page/playlist-page';

interface AlbumLinkProps {
  playlist: Playlist;
  className?: string;
}
export function PlaylistLink({playlist, className}: AlbumLinkProps) {
  const uri = useMemo(() => {
    return getPlaylistLink(playlist);
  }, [playlist.id]);

  if (!isIOSOrAndroid()) {
    return (
      <Link className={clsx('capitalize hover:underline', className)} to={uri}>
        {playlist.name}
      </Link>
    );
  }

  return (
    <StackTrigger moveFocusToDialog={false} title={playlist.name}>
      <div className={clsx('capitalize hover:underline', className)}>
        {playlist.name}
      </div>
      <PlaylistPage playlist={playlist} />
    </StackTrigger>
  );
}

export function getPlaylistLink(
  playlist: Playlist,
  {absolute}: {absolute?: boolean} = {},
) {
  const playlistName = slugifyString(playlist.name);
  let link = `/playlist/${playlist.id}/${playlistName}`;
  if (absolute) {
    link = `${getBootstrapData().settings.base_url}${link}`;
  }
  return link;
}
